import { CircularProgress, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  selectCourseCategories,
  setCourseCategories,
} from 'src/mentor/reducers/courses/coursesReducer'
import { getMPData } from 'src/mentor/services'
import MentorHeader from '../MentorHeader'
import { HomePageContainer, HomePageItem } from '../MentorHomePage/MentorHomepageStyles'

export default function OnlineCourseCategoryBoxes() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const categories = useSelector(selectCourseCategories)
  const dispatch = useDispatch()

  async function getCategories() {
    const resp = await getMPData('/api/secure/teacher/meta-categories')
    if (resp?.status === 200) {
      if (resp?.data) {
        const filteredMetaCategories = resp.data?.filter((item) => {
          return item?.categoryType === 'course'
        })
        dispatch(setCourseCategories(filteredMetaCategories))
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    getCategories()
  }, [])

  return (
    <>
      <MentorHeader heading="Course Categories" />
      <HomePageContainer>
        {loading && categories?.length === 0 ? (
          <CircularProgress />
        ) : (
          categories
            ?.slice()
            ?.sort((a, b) => {
              return a?.title.localeCompare(b?.title)
            })
            ?.map((cat) => (
              <Grid item key={cat?.id} xs={12} sm={6} lg={4} xl={3}>
                <HomePageItem onClick={() => navigate(cat?.id)}>{cat?.title}</HomePageItem>
              </Grid>
            ))
        )}
      </HomePageContainer>
    </>
  )
}
